module.exports = __webpack_public_path__ + "img/stackslash-process-7.42ffa815.jpg";